import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const findSchedulesInRegime = api((regimeId, scheduleId, version) =>
    query(
        gql`
            query FindSchedulesInRegime($regimeId: String!, $scheduleId: String!, $version: String) {
                findSchedulesInRegime(regimeId: $regimeId, scheduleId: $scheduleId, version: $version) {
                    id
                    where
                }
            }
        `,
        {
            regimeId,
            scheduleId,
            version,
        },
        {
            returns: "findSchedulesInRegime",
        }
    )
)
